module.exports = __webpack_public_path__ + "img/4.910d1bbb.jpg";